import React from 'react';
import { mapPinType } from '../../constants';
import { Box } from 'pcln-design-system';
import { Pin as PinIcon, Beach as BeachIcon, Restaurant as RestaurantIcon, KingBed as HotelIcon, Museum as MuseumIcon, Departure as AirportIcon, Attraction as AttractionIcon, Train as TrainIcon, Mountain as MountainIcon, Park as ParkIcon, Activity as ActivityIcon } from 'pcln-icons';
import styled from 'styled-components';
const IconBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SinglePinIcon__IconBox",
  componentId: "sc-eocgev-0"
})(["border-radius:50%;box-shadow:0px 1px 2px 0px rgba(0,0,0,0.5);width:24px;height:24px;svg{transform:translate(10%,10%);height:20px;width:20px;}"]);
export const MapIcon = ({
  type,
  iconProp
}) => {
  switch (type) {
    case mapPinType.MUSEUM:
      return React.createElement(MuseumIcon, Object.assign({}, iconProp));
    case mapPinType.BEACH:
      return React.createElement(BeachIcon, Object.assign({}, iconProp));
    case mapPinType.RESTAURANT:
      return React.createElement(RestaurantIcon, Object.assign({}, iconProp));
    case mapPinType.HOTEL:
      return React.createElement(HotelIcon, Object.assign({}, iconProp));
    case mapPinType.AIRPORT:
      return React.createElement(AirportIcon, Object.assign({}, iconProp));
    case mapPinType.MOUNTAIN:
      return React.createElement(MountainIcon, Object.assign({}, iconProp));
    case mapPinType.PARK:
      return React.createElement(ParkIcon, Object.assign({}, iconProp));
    case mapPinType.ACTIVITY:
      return React.createElement(ActivityIcon, Object.assign({}, iconProp));
    case mapPinType.ATTRACTION:
    case mapPinType.POI:
      return React.createElement(AttractionIcon, Object.assign({}, iconProp));
    case 'TRANSIT':
      return React.createElement(TrainIcon, Object.assign({}, iconProp));
    case 'CITY':
    default:
      return React.createElement(PinIcon, Object.assign({}, iconProp));
  }
};
export const SinglePinIcon = ({
  type
}) => {
  return React.createElement(IconBox, {
    bg: 'background.lightest'
  }, React.createElement(MapIcon, {
    type: type,
    iconProp: {
      color: 'primary.base'
    }
  }));
};